import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSyncOffmodule = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.70696 3.70711C4.09748 3.31658 4.75943 3.34536 5.18545 3.77139L20.6132 19.1992C21.0393 19.6252 21.068 20.2871 20.6775 20.6777C20.287 21.0682 19.625 21.0394 19.199 20.6134L3.77124 5.1856C3.34521 4.75958 3.31643 4.09763 3.70696 3.70711Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12 2.20954L12 3.99954C10.5157 3.99954 9.12614 4.40326 7.93506 5.10693L9.4136 6.58548C10.1971 6.20995 11.0743 5.99954 12 5.99954L12 7.78954C12 8.23954 12.54 8.45954 12.86 8.14954L15.65 5.35954C15.85 5.15954 15.85 4.84954 15.65 4.64954L12.85 1.85954C12.54 1.53954 12 1.75954 12 2.20954ZM17.4141 14.5859C17.7896 13.8025 18 12.9253 18 11.9995C18 11.2095 17.85 10.4395 17.56 9.74954C17.41 9.38954 17.52 8.97954 17.79 8.70954C18.3 8.19954 19.16 8.37954 19.43 9.04954C19.8 9.95954 20 10.9595 20 11.9995C20 13.4838 19.5963 14.8734 18.8926 16.0645L17.4141 14.5859ZM18.3201 16.9062L16.8892 15.4752C16.4998 16.0216 16.0212 16.5001 15.4748 16.8893L16.9058 18.3203C17.4341 17.9098 17.9095 17.4345 18.3201 16.9062ZM16.064 18.8927C14.8731 19.596 13.4839 19.9995 12 19.9995L12 21.7895C12 22.2395 11.46 22.4595 11.15 22.1395L8.36 19.3495C8.16 19.1495 8.16 18.8395 8.36 18.6395L11.15 15.8495C11.46 15.5395 12 15.7595 12 16.2095L12 17.9995C12.9253 17.9995 13.8022 17.7893 14.5854 17.4141L16.064 18.8927ZM6.58544 9.41417C6.21022 10.1974 6 11.0742 6 11.9995C6 12.7895 6.15 13.5595 6.44 14.2495C6.59 14.6095 6.48 15.0195 6.21 15.2895C5.7 15.7995 4.84 15.6195 4.57 14.9495C4.2 14.0395 4 13.0395 4 11.9995C4 10.5156 4.4035 9.12642 5.10683 7.93556L6.58544 9.41417ZM7.09331 5.6794C6.56508 6.09001 6.08973 6.56542 5.67919 7.09371L7.11021 8.52473C7.49949 7.97834 7.97798 7.49976 8.5243 7.11039L7.09331 5.6794Z",
			fill: "black"
		})
	]
});
const ForwardRef = forwardRef(SvgSyncOffmodule);
export default ForwardRef;
